import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

export type PayloadInjectorPayload = Record<string, any>

export interface PayloadInjector {
  getRegisterPayload: () => Promise<PayloadInjectorPayload>
  getCancelPayload: () => PayloadInjectorPayload
  getPausePayload: () => PayloadInjectorPayload
  getFinalizePayload: () => PayloadInjectorPayload
}

const defaultValue = {
  getRegisterPayload: () => Promise.resolve({}),
  getCancelPayload: () => ({}),
  getPausePayload: () => ({}),
  getFinalizePayload: () => ({})
}

export const PayloadInjectorContext =
  createContext<PayloadInjector>(defaultValue)

export interface PayloadInjectorProps extends PropsWithChildren {
  injector: Partial<PayloadInjector>
}

export function PayloadInjector({ children, ...props }: PayloadInjectorProps) {
  return (
    <PayloadInjectorContext.Provider
      value={{ ...defaultValue, ...props.injector }}
    >
      {children}
    </PayloadInjectorContext.Provider>
  )
}

export function usePayloadInjector() {
  return useContext(PayloadInjectorContext)
}
